import { getImageProps } from 'next/image'

import { BlogPost } from '@types'

import CommentsAndLikes from '@components/post-comments-and-likes'
import { getImageSrc, seoUrlPathEncode } from '@lib/helpers/client'
import getBackgroundImage from '@lib/helpers/cross-env/get-background-image'

import styles from './post-card.module.scss'
import Link from 'next/link'

type PostCardProps = {
  post: BlogPost
  className?: string
}

export default function PostCard({ post, className = '' }: PostCardProps): JSX.Element {
  const imageUrl = getImageSrc(post.image?.sizes, 'POST-THUMBNAIL')
  const imageProps = getImageProps({
    src: imageUrl || '/images/article/blog-placeholder.png',
    alt: post.title || 'SonicJobs Blog Post Featured Image',
    width: 350,
    height: 233,
    priority: false,
    loading: 'lazy',
  })

  const style = {
    backgroundImage: getBackgroundImage(imageProps.props.srcSet),
  }

  return (
    <Link
      key={post.id}
      href={`/blogs/${seoUrlPathEncode(post?.title, 'blog')}-${post.id}`}
      className={`${styles.article} ${className}`}
      data-pw="post-card"
    >
      <div className={styles['img-container']} style={style}></div>
      <CommentsAndLikes comments={post.numComments || 0} likes={post.likesCount || 0} className={styles.stats} />
      <div className={styles['post-title']}>{post.title}</div>
      <p className={styles.excerpt}>{post.excerpt.length > 100 ? `${post.excerpt.slice(0, 100)}...` : post.excerpt}</p>
      <p className={styles['read-more']}>Read more</p>
    </Link>
  )
}
